import { changeStatus } from '../redux/actions/status'
import { STATUS } from '../redux/types'

const friendlyMessages = {
  400: 'The request was invalid. Please check your input and try again.',
  401: 'Your session has expired. Please log in again.',
  403: 'You do not have permission to perform this action.',
  404: 'The requested resource was not found.',
  409: 'A conflict occurred. The resource may have been modified by another user.',
  422: 'The provided data is invalid. Please review and try again.',
  429: 'Too many requests. Please wait a moment and try again.',
  500: 'An unexpected server error occurred. Please try again later.',
  502: 'The server is temporarily unavailable. Please try again later.',
  503: 'The service is currently unavailable. Please try again later.',
}

export const handleError = (dispatch, error, context) => {
  if (error.response) {
    const status = error.response.status
    const serverMsg =
      error.response.data?.msg ||
      (typeof error.response.data === 'string' && error.response.data) ||
      error.response.data?.error?.code ||
      ''

    // Use server message if available, otherwise use friendly fallback
    const message =
      serverMsg || friendlyMessages[status] || 'Something went wrong.'

    const prefix = context ? `${context}: ` : ''

    dispatch(changeStatus(STATUS.ERROR, `${prefix}${message}`))
  } else if (error.request) {
    dispatch(
      changeStatus(
        STATUS.ERROR,
        'Unable to reach the server. Please check your connection.',
      ),
    )
  } else {
    dispatch(
      changeStatus(STATUS.ERROR, 'Something went wrong. Please try again.'),
    )
  }

  console.error(context || 'API Error:', error)
}
